import React, { Fragment } from "react"
import { formatNumber } from "@malond/utils"
import { Item } from "../../libs/api/backend/src"

interface RevisionItemTableProps {
  items: Item[]
  onClickCol: (item: Item) => void
  limit: number
  offset: number
}

export default function RevisionItemTable({
  items,
  onClickCol,
  limit,
  offset,
}: RevisionItemTableProps) {
  let from = offset
  let to = offset + limit

  if (items && items.length && items.length > to) {
    from = offset
    to = offset + limit
  }

  return (
    <Fragment>
      <div className="grid grid-cols-10 gap-0.5 divide-y divide-border overflow-hidden rounded-md border border-border bg-card text-xs">
        <RevisionItemTableRow
          col1={"П/П"}
          col2={"Штрихкод"}
          col3={
            <>
              <p className="truncate font-semibold text-foreground">Название</p>
              <p className="text-muted-foreground">Категория</p>
            </>
          }
          col4={"кол-во"}
        />

        {items && items.length ? (
          items.slice(from, to).map((item, index) => (
            <RevisionItemTableRow
              key={item.id}
              col1={index + 1 + offset}
              col2={
                <span
                  className="block h-8 p-1 font-mono transition-colors hover:cursor-pointer hover:bg-muted"
                  onClick={() => onClickCol(item)}
                >
                  {item.barcode}
                </span>
              }
              col3={
                <span
                  className="block p-1 transition-colors hover:cursor-pointer hover:bg-muted"
                  onClick={() => alert(item.title)}
                >
                  <p className="truncate font-medium text-foreground">
                    {item.title}
                  </p>
                  <p className="text-muted-foreground">
                    {item.categoryId && item.category
                      ? item.category.title
                      : "-"}
                  </p>
                </span>
              }
              col4={formatNumber(item.count)}
            />
          ))
        ) : (
          <div className="col-span-10 py-4 text-center text-muted-foreground">
            Нет товаров
          </div>
        )}
      </div>
    </Fragment>
  )
}

function RevisionItemTableRow({
  col1,
  col2,
  col3,
  col4,
}: {
  col1: any
  col2: any
  col3: any
  col4: any
}) {
  return (
    <>
      <div className="border-r text-right">{col1}</div>
      <div className="col-span-3 border-r text-right">{col2}</div>
      <div className="col-span-5 border-r">{col3}</div>
      <div className="text-right">{col4}</div>
    </>
  )
}
